module.exports = __webpack_public_path__ + "server/img/facebook_audience-9a37687c36f9ec8fb4af49989a7c83fcbf8b540d1fc190b26679ccc175c1a533.31907f4b.png";